import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Edit3 } from "lucide-react";
import classnames from "classnames";
import DeleteModal from "../../../Components/Common/DeleteModal";

const DestinationDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [intellData, setIntellData] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const fetchDestinationIntell = async () => {
    try {
      const response = await DestinationService.getDetailIntell(data?.id);
      setIntellData(response);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchDetail = async () => {
    setIsLoading(true);
    try {
      const response = await DestinationService.getBySlug(id);

      setData(response);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch destination details");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchDetail();
    }
  }, [id, navigate]);

  useEffect(() => {
    fetchDestinationIntell();
  }, [data?.id]);
  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="my-5 d-flex justify-content-center align-items-center">
            <Triangle visible height="80" width="80" color="#405189" />
          </div>
        </Container>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const breadcrumbItems = [
    { title: "Back to List", link: "/destination-countries" },
  ];

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await DestinationService.deleteDestinationIntell(selectedDeleteItem.id);
        fetchDestinationIntell();
        fetchDetail();
        toast.success("Selected record deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Destination Detail"
          pageTitle="Destination Countries"
          breadcrumbItems={breadcrumbItems}
        />

        {/* Banner Section */}
        <div className="">
          <div className=" bg-light">
            {data.bannerMedia ? (
              <img
                src={`${imageBaseApi}${data.bannerMedia?.url}`}
                alt=""
                className="img-fluid w-100 object-fit-contain"
                style={{ height: "250px" }}
              />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center bg-secondary text-white"
                style={{ height: "280px" }}
              >
                <span>No Banner Provided</span>
              </div>
            )}
          </div>
        </div>

        <div className="pt-4 mb-4">
          {/* Header Section */}

          <Row>
            <Col lg={4}>
              <Card className=" shadow-sm mb-4">
                <CardBody>
                  <Row className="align-items-center">
                    {/* Flag + Title */}
                    <Col lg={12} className="mb-2">
                      <div>
                        <h4 className="fw-bold mb-2">{data.name}</h4>
                      </div>

                      <Row className="text-muted small">
                        <Col md={12}>
                          <i className="ri-calendar-line me-1"></i>
                          <strong>Created:</strong>{" "}
                          {new Date(data.createdAt).toLocaleString()}
                        </Col>
                        <Col md={12}>
                          <i className="ri-time-line me-1"></i>
                          <strong>Last Updated:</strong>{" "}
                          {data.updatedAt
                            ? new Date(data.updatedAt).toLocaleString()
                            : "—"}
                        </Col>
                      </Row>
                    </Col>

                    {/* Action Button */}
                    <Col lg={12} className="">
                      <div className="d-flex justify-content-between align-content-center align-items-center">
                        <Badge
                          pill
                          color={data.isActive ? "success" : "secondary"}
                          className="px-3 py-2a"
                        >
                          {data.isActive ? "Active" : "Inactive"}
                        </Badge>
                        <Button
                          color="primary"
                          size="sm"
                          className="d-flex align-items-center "
                          onClick={() =>
                            navigate(
                              `/destination-countries/update/${data.slug}`,
                            )
                          }
                        >
                          <Edit3 size={14} />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <div
                    className="position-relative"
                    style={{ overflow: "hidden" }}
                  >
                    {data.flagMedia && (
                      <img
                        src={`${imageBaseApi}${data.flagMedia.url}`}
                        alt={data.name}
                        className="rounded border w-100"
                        style={{ height: "auto", objectFit: "contain" }}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
              {/* Metadata */}
            </Col>
            <Col>
              <Nav tabs className="mb-3">
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => toggleTab("1")}
                    style={{ cursor: "pointer" }}
                  >
                    Main Description
                  </NavLink>
                </NavItem>

                {/* <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => toggleTab("2")}
                  >
                    Info Boxes
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    className={activeTab === "3" ? "active" : ""}
                    onClick={() => toggleTab("3")}
                  >
                    Post-Study Work
                  </NavLink>
                </NavItem> */}

                <NavItem>
                  <NavLink
                    className={activeTab === "4" ? "active" : ""}
                    onClick={() => toggleTab("4")}
                    style={{ cursor: "pointer" }}
                  >
                    Assign Universities
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "5" ? "active" : ""}
                    onClick={() => toggleTab("5")}
                    style={{ cursor: "pointer" }}
                  >
                    Destination Intelligence
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                {/* Main Description */}
                <TabPane tabId="1">
                  {data?.description && (
                    <Card className="shadow-sm">
                      <CardBody>
                        <div
                          className="text-muted"
                          dangerouslySetInnerHTML={{
                            __html: data.description,
                          }}
                        />
                      </CardBody>
                    </Card>
                  )}
                </TabPane>

                {/* Info Boxes */}
                <TabPane tabId="2">
                  {data?.subDetails?.map((item) => (
                    <Card key={item.id} className="shadow-sm mb-2">
                      <CardHeader className="bg-transparent">
                        <h6 className="fw-semibold mb-0">{item.title}</h6>
                      </CardHeader>
                      <CardBody>
                        <div
                          className="text-muted"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                        {item.media?.url && (
                          <img
                            src={`${imageBaseApi}${item.media.url}`}
                            className="img-fluid rounded mt-2"
                            alt={item.title}
                          />
                        )}
                      </CardBody>
                    </Card>
                  ))}
                </TabPane>

                {/* Post Study Work */}
                <TabPane tabId="3">
                  {data?.postStudyWork && (
                    <Card className="shadow-sm">
                      <CardBody>
                        <div
                          className="text-muted"
                          dangerouslySetInnerHTML={{
                            __html: data.postStudyWork,
                          }}
                        />
                      </CardBody>
                    </Card>
                  )}
                </TabPane>

                {/* Additional Information */}
                <TabPane tabId="4">
                  <Row>
                    {data?.universities?.map((item) => (
                      <Col md={6} lg={4} key={item.id}>
                        <Card className="">
                          <img
                            src={`${imageBaseApi}${item.logo?.url}`}
                            className="img-fluid rounded-top"
                            style={{ height: "120px", objectFit: "contain" }}
                            alt={item.fileName}
                          />
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </TabPane>

                <TabPane tabId="5">
                  <Row>
                    <div className="d-flex justify-content-between align-content-center align-items-center mb-3">
                      <h5>Destination's Flow</h5>
                      <div className="d-flex gap-2 justify-content-center align-content-center align-items-center">
                        {intellData?.length > 0 && (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              navigate(
                                `/destination-intelligence/update/${data?.id}`,
                              )
                            }
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                        )}
                      </div>
                    </div>
                    {intellData?.length > 0 ? (
                      intellData?.map((item) => (
                        <>
                          <Col lg={12} key={item.id}>
                            <Card className="">
                              <CardBody>
                                <div className="d-flex justify-content-between align-content-center align-items-center">
                                  <CardTitle tag="h5">
                                    {item.headingName}
                                  </CardTitle>

                                  <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() => handleDeleteClick(item)}
                                  >
                                    <i className="ri-delete-bin-5-line"></i>
                                  </Button>
                                </div>
                                <h6 className="text-secondary">{item?.ur}</h6>

                                {/* <CardText>{item.description}</CardText> */}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                />
                              </CardBody>
                            </Card>
                          </Col>
                        </>
                      ))
                    ) : (
                      <Card className="shadow-sm border-0">
                        <CardBody className="p-5 text-center">
                          {/* Icon */}
                          <div className="mb-3">
                            <i
                              className="bi bi-lightbulb text-warning"
                              style={{ fontSize: "3rem" }}
                            />
                          </div>

                          {/* Title */}
                          <h5 className="fw-bold mb-2">
                            No Intelligence Found
                          </h5>

                          {/* Description */}
                          <p className="text-muted mb-4">
                            Intelligence has not been created for this
                            destination yet.
                          </p>

                          {/* Action Button */}
                          <button
                            className="btn btn-success px-4"
                            onClick={() =>
                              navigate(
                                `/destination-intelligence/create/${data?.id}`,
                              )
                            }
                          >
                            <i className="bi bi-plus-circle me-2" />
                            Add Intelligence
                          </button>
                        </CardBody>
                      </Card>
                    )}
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </div>
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default DestinationDetail;
